<template>
  <component :is="layout">
    <router-view />
  </component>

  <!-- NewUserModal — not needed for admin panel -->
  <!-- <NewUserModal v-if="showModal" :show="showModal" @close="handleCloseModal" @save="handleSaveModal" /> -->

  <!-- Shown once when any API call returns 401/403 — see services/error/sessionExpired.js -->
  <SessionExpiredModal v-if="sessionExpired" :message="sessionExpiredMessage" />
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
// import { useStore } from 'vuex'; // not needed — getMe/notifications commented out
// import { useRouter } from 'vue-router'; // not needed — no programmatic redirects

import { applyScheme, getSavedScheme, getSystemScheme, initSystemSchemeListener } from '@/utils/colorSchemeUtils.js';

import defaultLayout from './layouts/default.vue';
import guestLayout from './layouts/guest.vue';

// NEW: global session-expired popup (one blocking dialog when any API call
// returns 401/403, "Log In" button → /sign-in)
import SessionExpiredModal from '@/components/modals/SessionExpiredModal.vue';
import { sessionExpired, sessionExpiredMessage } from '@/services/error/sessionExpired.js';

// ── Unused in admin panel ──────────────────────────────────────────────────
// import NewUserModal from '@/components/modals/firstTimeModal.vue';
// import { io } from 'socket.io-client';
// import { getUserFriendlyErrorMessage } from '@/utils/errorHandler';
// import { enableScroll } from '@/utils/scrollControl.js';
// import { usePushNotifications } from '@/composables/usePushNotifications';
// import FullPageLoader from '@/components/FullPageLoader.vue';
// ─────────────────────────────────────────────────────────────────────────

// const store = useStore(); // not needed — getMe/notifications commented out
const route = useRoute();
// const router = useRouter(); // not needed — no programmatic redirects

const layout = computed(() => {
  const l = route.meta.layout;
  return l === 'default' ? defaultLayout : guestLayout;
});

let unregisterSystemSchemeListener;

onMounted(async () => {
  try {
    applyScheme(getSavedScheme() || getSystemScheme());
    unregisterSystemSchemeListener = initSystemSchemeListener();

    // Name is sourced from /auth/login-sms/check (localStorage) — no server call needed on load
    // const hadSession = !!localStorage.getItem('user');
    // const userData = await store.dispatch('getMe'); // commented out — causes 401 to clear auth state
    // if (userData) {
    //   store.dispatch('fetchUnreadNotificationsCount'); // /api/notifications/unread — not called on load
    // } else if (hadSession && route.meta?.auth !== false) {
    //   router.replace('/sign-in');
    // }
  } catch (error) {
    console.warn(error);
  }
});

onUnmounted(() => {
  if (unregisterSystemSchemeListener) {
    unregisterSystemSchemeListener();
  }
});

// ── All launch_pad_fe services commented out (not needed for admin panel) ──
//
// const logOut = payload => store.dispatch('logOut', payload);
// const addAuthStatus = status => store.dispatch('addAuthStatus', status);
// const getReportPost = id => store.dispatch('fetchReportBotId', id);
// const handleSetProfile = data => store.dispatch('fetchCurrentProfileOrg', data);
// const userdata = JSON.parse(localStorage.getItem('user'));
// const user = computed(() => store.getters.getUser);
// const userId = computed(() => store.getters.getUser?.id);
// const token = computed(() => store.getters.getToken);
// const isRouteLoading = computed(() => store.getters.getIsRouteLoading);
//
// const showModal = ref(false);
// const { showPermissionPrompt, initPushNotifications, enablePushNotifications, listenForForegroundMessages } = usePushNotifications();
// let authenticatedServicesStarted = false;
// let pushNotificationsStarted = false;
// let socketStarted = false;
// const ENABLE_SOCKET = String(import.meta.env.VITE_ENABLE_SOCKET || '').toLowerCase() === 'true';
// const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || '/';
//
// const checkPopupStatus = async () => { ... };
// const handleCloseModal = () => { showModal.value = false; };
// const handleSaveModal = async () => { ... };
// const useSocketIO = () => { ... };
// const startAuthenticatedAppServices = async () => { ... };
// const handleUserLoggedIn = () => { setTimeout(() => startAuthenticatedAppServices(), 400); };
// window.addEventListener("user-logged-in", handleUserLoggedIn);
//
// router.afterEach((to) => {
//   if (to?.meta?.layout === 'guest') {
//     enableScroll();
//     document.body.classList.remove('modal-open');
//     ...
//   }
// });
</script>

<style>
:root {
  --header-height: 80px;
  --bottom-nav-height: 64px;
}

.posts-scroll-container,
.centerbar-posts {
  overscroll-behavior: contain;
}
</style>
